import React from 'react';
import 'styled-components/macro';
import { Box, Grid, Typography } from '@material-ui/core';
import { TextButton } from 'app/components/Buttons/TextButton';
import { FilledButton } from 'app/components/Buttons/FilledButton';

interface BottomControlsProps {
  selectedOptions: any;
  disableApply?: boolean;
  displaySelected?: boolean;
  handleApplyClick: Function;
  handleCancelClick: Function;
}

export const BottomControls: React.FunctionComponent<BottomControlsProps> = (
  props
) => (
  <Grid container alignItems="center" justifyContent="space-between">
    {/* ------------------------------------ */}
    {/* selected indicator */}
    <Grid item sm={4} md={4} lg={6}>
      {props.displaySelected && (
        <Typography
          css={`
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 1;
            display: flex;
            align-items: center;
            text-align: center;
            color: rgba(61, 61, 61, 0.6);
            transform: translateX(1px);
          `}
        >
          {props.selectedOptions.length} selected
        </Typography>
      )}
    </Grid>

    {/* ------------------------------------ */}
    {/* buttons */}
    <Grid
      item
      sm={8}
      md={8}
      lg={6}
      css={`
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
      `}
    >
      <TextButton label="Cancel" onClick={() => props.handleCancelClick()} />
      <Box width="24px" />
      <FilledButton
        aria-label="Apply filter"
        label="Apply"
        onClick={() => props.handleApplyClick()}
        disabled={props.disableApply}
      />
    </Grid>
  </Grid>
);
